export default __webpack_public_path__ + "static/media/082209_0914.7e7f37ab.jpg";